import { Row, Col, Container, Button } from "react-bootstrap";
import MainNav from "../Global/MainNav";
import Footer from "../Global/Footer";
import Image from "react-bootstrap/Image";
import About from "../About/About";
import Portfolio from "../Portfolio/Portfolio";
import Socials from "../Utils/socials";
import me from "../../images/me.jpg";
import Contact from "../Contact/Contact";
import SkillsComp from "../SkillsComp/SkillsComp";

const Home = ({ fieldState }) => {
  const webDev = fieldState["Web Development"] == true;

  return (
    <section
      id="home"
      className="home animate__animated animate__fadeIn animate__slow"
    >
      <MainNav />
      <section className="home_header justify-content-between d-flex align-items-center">
        <div className="home_header-info  d-flex flex-row-reverse ">
          <div className="justify-content-end">
            <div className="d-none d-xl-block home_header-img-container">
              <Image src={me} />
            </div>
          </div>
          <Container className="d-flex flex-column justify-content-center px-4 px-lg-5">
            <h2 className="home_header_name ">
              Cheyenne <br /> Threadgill
            </h2>
            <h1 className="fw-bold ">{webDev ? "Junior Front-End Web Developer" : "Graphic Designer"}</h1>
            <p>
              {" "}
              {webDev
                ? "Hi, I'm Cheyenne Threadgill. A Junior Front-End Web Developer based in Raleigh, NC."
                : "Hi, I'm Cheyenne Threadgill. A Graphic Designer based in Raleigh, NC."}{" "}
            </p>

            <div>
              <h6 className=" fw-semibold d-flex align-items-center gap-3">
                Contact Me: <Socials webDev={webDev} />
              </h6>
            </div>
          </Container>
        </div>

        {/* Second Row------------------------------ */}
      </section>
      {/* Header-END-------------------------------- */}

      {/* skills */}
      {webDev && <SkillsComp />}

      <About />
      <Portfolio webDev={webDev} />
      <Contact />
      <Footer />
    </section>
  );
};

export default Home;
